import { FC } from "react";
import IconButton from "@mui/material/IconButton";
import styles from "./TopHeader.module.css";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Clear from "@mui/icons-material/Clear";

// ==============================================================
// Update Props to include handleCartAmountChange
interface Props {
  total: number; // Total sum of all quantities
  toggle: () => void;
  onClose?: () => void; // Add onClose as an optional prop
}
// ==============================================================

const TopHeader: FC<Props> = ({ toggle, total }) => {
  return (
    <div className={styles.cartHeader}>
      <div className={styles.cartHeaderContainer}>
        <div className={styles.cartHeaderLeft}>
          <div className={styles.icon}>
            <ShoppingCartOutlinedIcon />
          </div>
          {total === 1 ? (
            <div className={styles.title}>1 producto</div>
          ) : (
            <div className={styles.title}>{total} productos</div>
          )}
        </div>
        <div className={styles.cartHeaderRight}>
          <IconButton onClick={toggle}>
            <Clear />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
